import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SignalFilledSvg from "@ant-design/icons-svg/es/asn/SignalFilled";
import AntdIcon from "../components/AntdIcon";
var SignalFilled = function SignalFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SignalFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SignalFilled.displayName = 'SignalFilled';
}
export default /*#__PURE__*/React.forwardRef(SignalFilled);